import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/approvalActions';
import { approvalsAPI } from '../../api/config';

function* fetchApprovalConfigSaga() {
  try {
    const response = yield call(approvalsAPI.getConfig);
    yield put(actions.fetchApprovalConfigSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch approval config';
    yield put(actions.fetchApprovalConfigFailure(msg));
  }
}

function* updateApprovalConfigSaga(action) {
  try {
    const response = yield call(approvalsAPI.updateConfig, action.payload);
    yield put(actions.updateApprovalConfigSuccess(response.data));
    message.success('Approval configuration updated successfully');
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to update approval config';
    yield put(actions.updateApprovalConfigFailure(msg));
    message.error(msg);
  }
}

function* fetchPendingApprovalsSaga() {
  try {
    const response = yield call(approvalsAPI.getPendingApprovals);
    yield put(actions.fetchPendingApprovalsSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch pending approvals';
    yield put(actions.fetchPendingApprovalsFailure(msg));
    message.error(msg);
  }
}

function* fetchPOApprovalStatusSaga(action) {
  try {
    const response = yield call(approvalsAPI.getPOApprovalStatus, action.payload);
    yield put(actions.fetchPOApprovalStatusSuccess(action.payload, response.data));
  } catch (error) {
    // 404 means no approval request — not an error to surface
    yield put(actions.fetchPOApprovalStatusFailure(error.message));
  }
}

function* approvePOSaga(action) {
  try {
    const { poId, data } = action.payload;
    const response = yield call(approvalsAPI.approvePO, poId, data);
    yield put(actions.approvePOSuccess(response.data));
    message.success('Purchase order approved — status changed to Open');
    // Refresh pending list
    yield put(actions.fetchPendingApprovalsRequest());
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to approve purchase order';
    yield put(actions.approvePOFailure(msg));
    message.error(msg);
  }
}

function* rejectPOApprovalSaga(action) {
  try {
    const { poId, data } = action.payload;
    const response = yield call(approvalsAPI.rejectPOApproval, poId, data);
    yield put(actions.rejectPOApprovalSuccess(response.data));
    message.success('Purchase order approval rejected — order cancelled');
    // Refresh pending list
    yield put(actions.fetchPendingApprovalsRequest());
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to reject approval';
    yield put(actions.rejectPOApprovalFailure(msg));
    message.error(msg);
  }
}

export default function* approvalSaga() {
  yield takeLatest(types.FETCH_APPROVAL_CONFIG_REQUEST, fetchApprovalConfigSaga);
  yield takeLatest(types.UPDATE_APPROVAL_CONFIG_REQUEST, updateApprovalConfigSaga);
  yield takeLatest(types.FETCH_PENDING_APPROVALS_REQUEST, fetchPendingApprovalsSaga);
  yield takeLatest(types.FETCH_PO_APPROVAL_STATUS_REQUEST, fetchPOApprovalStatusSaga);
  yield takeLatest(types.APPROVE_PO_REQUEST, approvePOSaga);
  yield takeLatest(types.REJECT_PO_APPROVAL_REQUEST, rejectPOApprovalSaga);
}
